export const managementModels = {
    DIRECT_ESTIMATE: 'Estimación Directa',
    ESTIMATE_BY_MODULES: 'Estimación por Módulos',
    OTHERS: 'Otros'
};

export const memberStatusOptions = [
    {key: 1, value: 'Alta'},
    {key: 0, value: 'Baja'},
];

export const memberLocatedOptions = [
    {key: 1, value: 'Localizable'},
    {key: 0, value: 'Ilocalizable'},
];

export const memberReceiptIssueDatesOptions = [
    {key: 1, value: 'Enero'},
    {key: 2, value: 'Febrero'},
    {key: 3, value: 'Marzo'},
    {key: 4, value: 'Abril'},
    {key: 5, value: 'Mayo'},
    {key: 6, value: 'Junio'},
    {key: 7, value: 'Julio'},
    {key: 8, value: 'Agosto'},
    {key: 9, value: 'Septiembre'},
    {key: 10, value: 'Octubre'},
    {key: 11, value: 'Noviembre'},
    {key: 12, value: 'Diciembre'}
];